internalRedirect();

$(document).ready( function() {
    redirect();
    widePagesList();
    //customCheckout();
    closeCart();
});

function redirect()
{
    let data = storeData();
    for (let i in data)
    {
        let target = 'a[href^="' + data[i][0] + '"]';
        $(target).on("click", function() {
            $.ajax( $(this).attr('href') )
                .done(function() {
                    let domain = "https://my.spartancamera.com"
                    window.location.href = domain + data[i][1];
                });
            return false;
        });
    }
}

function storeData()
{
    let store = new Map();

    store[0] = [
        "/account/logout",
        "/shop/ssologout"
    ];

    store[1] = [
        "/account/login",
        "/shop/ssologin"
    ];

    return store;
}

function widePagesList()
{
    const widePages = [
        "/",
        "/pages/data-plan",
        "/account", 
    ];
      
    const pathName = window.location.pathname;

    if (widePages.indexOf(pathName) === -1 && pathName.indexOf("product") === -1)
    {
        let contains = $("#MainContent");
        contains.addClass("exceptWide-Custom");
    }
}

function customCheckout()
{
    let checkoutArr = document.getElementsByClassName("custom-checkout-redirect");
    let checkoutLength = checkoutArr.length;
    for (let i = 0; i < checkoutLength; i++)
    {
        cartWithoutLoginRedirect(checkoutArr[i]);
    }
}

function cartWithoutLoginRedirect(checkout)
{
    let back = $("#checkoutRedirectBack").val();
    checkout.onclick = function() {
        let path = storeData();
        let domain = "https://my.spartancamera.com"
        window.location.href = domain + path[1][1] + "/" + back;
        return false;
    };
}

function closeCart()
{
    let buttonCart = $(".product-form__item--submit");
    buttonCart.click(function(){
        let outCartSide = $('body *').not('#SideCart, #SideCart *, .product-form__item--submit, .product-form__item--submit *');
        let innerCart = $(".side-cart-overlay");
        let sideCart = $("#SideCart");
        outCartSide.click(function(){
            sideCart.removeClass("slide-in");
            innerCart.removeClass("cart-open");
        });
    });

}

function internalRedirect()
{
    const redirects = {
        "/products": "/collections/all-products",
        "/collections" : "/"
    };

    const path = window.location.pathname;
    const url = window.location.href;

    if (path in redirects)
    {
        window.location.href = redirects[path];
    }

    if (url.indexOf("checkout") !== -1)
    {
        let domain = "https://my.spartancamera.com"
        window.location.href = domain  + "/shop/ssologin/cart";
    }
}

